import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {FilterDisplayContainer} from 'components/FilterDisplayContainer/FilterDisplayContainer'
import {filterMessages} from 'components/Filters/filterMessages'
import {PropertyBrandFilter} from 'components/Filters/PropertyBrandFilter'
import {getFacetFilterPillLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getPropertyBrands} from 'modules/sapiSearch/selectors'
import {toArray} from 'utils/object'

interface Props {
  isActive?: boolean
}

const filterKeys = ['brandIds']

export const PropertyBrandFilterPopover: React.FC<Props> = ({
  isActive = false
}) => {
  const {formatMessage} = useIntl()
  const {
    submitFilters,
    getFilters,
    toggleMultiFilter,
    clearFilters,
    resetFilters,
    trackFilterClick,
    getAppliedFilters
  } = useFiltersForm(filterKeys)

  const filters = getFilters()
  const appliedFilters = getAppliedFilters()
  const propertyBrands = useSelector(getPropertyBrands)

  const {brandIds, appliedBrandIds} = useMemo(() => {
    return {
      brandIds: toArray(filters.brandIds),
      appliedBrandIds: toArray(appliedFilters.brandIds)
    }
  }, [filters, appliedFilters])

  const propertyBrandLabel = useMemo(
    () =>
      getFacetFilterPillLabel(
        propertyBrands,
        appliedBrandIds,
        formatMessage(filterMessages.propertyBrand)
      ),
    [appliedBrandIds, propertyBrands, formatMessage]
  )

  if (propertyBrands?.length === 0 || !propertyBrandLabel) return null

  return (
    <FilterDisplayContainer
      dataId="propertyBrandFilter"
      label={propertyBrandLabel}
      title={formatMessage(filterMessages.propertyBrand)}
      isActive={isActive}
      onClear={clearFilters}
      onApply={submitFilters}
      onClose={resetFilters}
      onPillClick={trackFilterClick}
    >
      <PropertyBrandFilter
        brands={propertyBrands}
        selectedBrandIds={brandIds}
        onChange={toggleMultiFilter}
        isExpandable={false}
        variant="two-columns"
      />
    </FilterDisplayContainer>
  )
}
